<script setup>

const props = defineProps({
	item: {
		type: Object,
		required: true
	},
	parent: {
		type: [Object, Boolean],
		required: false,
		default: false
	}
});
const {
	addItemExclusive,
	isItemAdded,
	toggleIata,
	isMaxIatasAdded,
	isItemHovered,
	setHoveredItem
} = inject('searchFieldMultiHelpers');

const isHovered = computed(() => isItemHovered(props.item));

function onMouseEnter () {
	setHoveredItem(props.item);
}
</script>

<template>
  <div
    class="SearchFieldMulti__row"
    :class="{
      'SearchFieldMulti__row  destination': !parent,
      'SearchFieldMulti__child_row': parent,
      'SearchFieldMulti__row--hovered': isHovered,
      'SearchFieldMulti__child_row--popular': item.is_popular && parent
    }"
    @pointermove="onMouseEnter"
    @click.stop.prevent="addItemExclusive(item, parent)"
  >
    <div class="SearchFieldMulti__row__inner">
      <span class="searchfield-icons-plane" />
      <span v-html="item.text" />
      <div class="SearchFieldMulti__most_popular_flag">
        {{ $l('module.searchfield.most_popular_singular') }}
      </div>
    </div>
    <div
      class="SearchFieldMulti__checkbox"
      :class="{
        'SearchFieldMulti__checkbox--checked': isItemAdded(item, false) || isItemAdded(parent, true),
        'SearchFieldMulti__checkbox--disabled': !(isItemAdded(item, false) || isItemAdded(parent, true)) && isMaxIatasAdded
      }"
      @click.stop.prevent="toggleIata(item, parent)"
      @touchend.prevent="toggleIata(item, parent)"
    >
      <div class="SearchFieldMulti__checkbox__icon">
        +
      </div>
    </div>
  </div>
</template>
